import { capitalize } from './string';

export const combineAddressFields = (address: any) => {
  let _addStr = '';
  const _keys = ['house_number', 'address1', 'address2', 'address3', 'address4'];
  _keys.map((key) => {
    if (address?.[key]) {
      _addStr = _addStr.concat(' ').concat(`${address?.[key]},`);
    }
  });
  return _addStr;
};

export const getAddress = (address: any): string => {
  return `${combineAddressFields(address)} ${address.city ? `${address.city},` : ''} ${
    address.state ? `${capitalize(address.state)}` : ''
  } ${address.postal_code ? `${address.postal_code}` : ''}`;
};
